import $ from 'jquery'
/**
 * @param {Object} config
 * @constructor
 */
export default function ImageViewer(config) {
  $.extend(this, config || {})

  this.$viewer = $('#image-viewer')
  this.$viewer
    .css({
      position: 'absolute',
      width: '100%',
      height: '100%',
      'background-color': 'rgba(0, 0, 0, 0.8)',
      'z-index': 10000
    })
    .hide()

  this.$viewer.on('click', this.close.bind(this))
}

/**
 * Show images
 * @param {string} imageUrl
 */
ImageViewer.prototype.show = function(imageUrl) {
  const $image = $('<img />')
    .css({
      'max-width': '100%',
      'max-height': '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
      padding: 20
    })
    .attr('src', imageUrl)

  const $closeIcon = $('<i></i>')
    .addClass('fa fa-times-circle icon-only')
    .css({
      color: '#fff',
      position: 'absolute',
      'font-size': 24,
      right: 20,
      top: 20
    })

  this.$viewer.append($image).fadeIn()
  this.$viewer.append($closeIcon)
}

/**
 * Close image
 */
ImageViewer.prototype.close = function(imageUrl) {
  this.$viewer.fadeOut(function() {
    $(this)
      .empty()
      .hide()
  })
}
